(function() {
  var Site;

  Site = Site || {};

  String.prototype.underscore = function() {
    this.toLowerCase().replace(/_|-|\s/g, '_');
  };

  (function($) {
    Site = {
      init: function() {
        var section;
        section = this.section();
        Site.sections.all.init();
        if (section) {
          return Site.sections[section].init();
        }
      },
      section: function() {
        var section, sections, _i, _len;
        sections = this.get_sections();
        for (_i = 0, _len = sections.length; _i < _len; _i++) {
          section = sections[_i];
          if ($('body.template-' + section).size()) {
            return section;
            break;
          }
        }
      },
      get_sections: function() {
        return $.map(Site.sections, function(obj, key) {
          return key;
        });
      }
    };
    Site.sections = {
      all: {
        init: function() {
          Site.sections.all.fancybox();
          //Site.sections.all.navigation();
          return Site.sections.all.sign_up_form();
        },
        fancybox: function() {
          return $('.fancybox').fancybox({
            loop: true,
            padding: 2,
            nextEffect: 'elastic',
            prevEffect: 'elastic'
          });
        },
        sign_up_form: function() {
          return $('#cm-subscriber').submit(function(event) {
            var email, valid_email;
            valid_email = /\w{1,}[@][\w\-]{1,}([.]([\w\-]{1,})){1,3}$/;
            email = $(this).find('#cm-email');
            if (valid_email.test(email.val()) === false) {
              $('<p id="email-error">Please enter a valid email address</p>').insertAfter(email);
              return event.preventDefault();
            } else {
              return Site.sections.all.write_cookie();
            }
          });
        },
        read_cookie: function() {
          return $.cookie('secret_south_sign_up');
        },
        write_cookie: function() {
          return $.cookie('secret_south_sign_up', 'registered', {
            expires: 356,
            path: '/',
            domain: '.secretsouth.com.au'
          });
        }
      },
      index: {
        init: function() {
          Site.sections.index.container();
          return Site.sections.index.sign_up_form();
        },
        container: function() {
          var element;
          element = $('#container');
          if (element.height() < $(window).height()) {
            element.addClass('center');
          }
          return element.find('#header-main').css('cursor', 'pointer').click(function() {
            return window.location = element.find('#section-main a').attr('href');
          });
        },
        sign_up_form: function() {
          var element;
          if (Site.sections.all.read_cookie() === null) {
            element = $('#cm-subscriber');
            return element.fadeIn().find('.close').click(function(event) {
              event.preventDefault();
              return element.fadeOut();
            });
          }
        }
      },
      collection: {
        init: function() {
          return Site.sections.collection.details();
        },
        details: function() {
          /*$('article.collection').each(function() {
            var article, detail, url;
            article = $(this);
            detail = article.find('.details');
            url = detail.find('a').attr('href');
            detail.center().hide();
            return article.hover((function() {
              return detail.fadeIn('fast');
            }), function() {
              return detail.fadeOut('fast');
            }).click(function(event) {
              window.location = url;
              return event.preventDefault();
            }).css('cursor', 'pointer');
          });*/
          return $('img.lazy').show().lazyload({
            effect: 'fadeIn',
            threshold: 300
          }).slice(0, 6).trigger('appear').end().parent('a').css({
            display: 'block',
            background: 'url(http://cdn.shopify.com/s/files/1/0171/6176/t/3/assets/loader.gif?1) no-repeat 50% 50%',
            width: '240px',
            height: '240px'
          });
        },
        random: function() {
          $('.random-collection article').pick(3).show();
          return Site.sections.collection.details();
        }
      },
      product: {
        init: function() {
          Site.sections.product.navigation();
          Site.sections.product.colours();
          //Site.sections.product.slides();
          Site.sections.product.tabs();
          Site.sections.product.guides();
          //Site.sections.product.selectors();
          Site.sections.product.preorder();
          return Site.sections.collection.random();
        },
        navigation: function() {
          var elements;
          elements = $('#nav-shop a');
          if (elements.filter('.focus').size() === 0 && Shopify.product) {
            return elements.each(function() {
              var element;
              element = $(this);
              if (Shopify.product.tags.indexOf(element.text()) >= 0) {
                element.addClass('focus');
                return false;
              }
            });
          }
        },
        slides: function() {
  var element, links;
  element = $('article.product');
  links = element.find('a');
  if (links.size() > 1) {
	return element.find('.slides').slidesjs({
        width: 480,
        height: 480,
        navigation: {
          active: false,
        },
        pagination: {
          active: false
        },
        effect: {
          slide: {
            speed: 500
          }
        }
	});
  } else {
	return links.first().fadeIn();
  }
},
        tabs: function() {
          var links, tab_items, table, tabs;
          tabs = $('#tabs');
          table = tabs.find('#description table');
          if (table.size()) {
            tabs.find('nav ul').append('<li><a href="#size-fit">Size &amp; Fit</a></li>');
            tabs.append($('<div>', {
              id: 'size-fit'
            }).html(table.show()).hide());
            links = $('#tabs nav a');
            tab_items = $("#description, #size-fit");
            return links.click(function(event) {
              event.preventDefault();
              if (!$(this).hasClass('focus')) {
                links.toggleClass('focus');
                return tab_items.toggle();
              }
            }).last().parent().addClass('right');
          }
        },
        guides: function() {
          var cols, container, html, panes, table, tabs, tfoot;
          table = $('#size-fit table');
          if (table) {
            html = 'All measurements are in centimetres. View the <a href="#template-measurements" class="measurement-box">measurement guide &amp; international sizes.</a>';
            cols = table.find('tr:first-child td').size();
            tfoot = $('<tfoot>').append($('<td>', {
              colspan: cols
            }).html(html));
            table.find('tfoot').remove().end().append(tfoot);
          }
          $('.measurement-box').fancybox({
            maxWidth: 600,
            maxHeight: 710,
            height: '100%',
            fitToView: false,
            autoSize: false,
            wrapCSS: 'fancybox-white'
          });
          container = $('#template-measurements');
          tabs = container.find('.tabs a');
          panes = container.find('.pane');
          return tabs.on('click', function(event) {
            var element, selector;
            element = $(this);
            selector = element.attr('href');
            panes.hide();
            $(selector).show();
            tabs.removeClass('focus');
            element.addClass('focus');
            return event.preventDefault();
          }).first().trigger('click');
        },
        colours: function() {
          if ($('#colours li').size() === 0) {
            return $('#colours').remove();
          }
        },
        selectors: function() {
          var selectors, variant, _i, _len, _ref, _results;
          if ($('#product-select').size() > 0) {
            selectors = new Shopify.LinkedOptionSelectors('product-select', {
              product: Shopify.product,
              onVariantSelected: function(variant, selector) {
                var old_price, price;
                if (variant && variant.available) {
                  price = Shopify.formatMoney(variant.price, Shopify.money_with_currency_format);
                  if (variant.compare_at_price > variant.price) {
                    old_price = Shopify.formatMoney(variant.compare_at_price, Shopify.money_with_currency_format);
                    price = "" + price + " <del>" + old_price + "</del>";
                  }
                  return $('#data-price').html(price);
                }
              }
            });
          }
          _ref = Shopify.product.variants;
          _results = [];
          for (_i = 0, _len = _ref.length; _i < _len; _i++) {
            variant = _ref[_i];
            if (!variant.available) {
              _results.push($("option[value=" + variant.options[0] + "]").remove());
            } else {
              _results.push(void 0);
            }
          }
          return _results;
        },
        preorder: function() {
          return $('input[data-preorder]').on('click', function() {
            return alert($(this).data('preorder'));
          });
        }
      },
      cart: {
        init: function() {
          return Site.sections.cart.note();
        },
        note: function() {
          return $('#toggle-note').css('cursor', 'pointer').hover(function() {
            return $(this).toggleClass('focus').click(function() {
              return $('#note').toggle();
            });
          });
        }
      },
      page: {
        init: function() {
          return Site.sections.page.tabs();
        },
        tabs: function() {
          if ($('.customer-service').size()) {
            $('#section-main').tabinate();
            return $('a[href=#tab-returns-shipping]').trigger('click');
          }
        }
      }
    };
    return $(function() {
      return Site.init();
    });
  })(jQuery);

}).call(this);
